export const ACTION_TYPE = {
    INIT:'INIT'
}